import { Button, Input, Form, notification, Modal, Tooltip, Icon, Row, Col } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import { connect, useDispatch } from 'react-redux'
import {
  addPropertyImageFxn,
  getPropertyGrpFxn,
  updatedAllPropertyGrpFxn,
  updatedAllPropertyStatusInActiveFxn
} from '../action'
import { DurationTypes } from '../utils/propertyUtils'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import FileInput from '../../../components/_utils/fileInput'
import { updatedAllPropertyPriceByGrpFxn } from '../action/index'

const initialState = {
  imageDrawerVisible: false,
  type: '',
  caption: '',
  image: {},
  imageKey: moment(),
};

const { TextArea } = Input;

const UpdateGroupPrice = (props) => {
  const dispatch = useDispatch();
  let [state, setState] = useState(initialState);
  const [propertyGroupData, setPropertyGroupData] = useState('')
  const [propertyGrpList, setPropertyGrpList] = useState([])
  let { propertyId, visible,roomId, onClose, imageData,tableRef, refreshData,filterState,filters, form : {getFieldDecorator, setFieldsValue, resetFields} } = props;

  const events = {
    getDistinctPropertyGrp: async () => {
      let { data } = await dispatch(getPropertyGrpFxn())
      setPropertyGrpList(data)
    },
    getParamsForInventoryList: () => {
      let { id, name, property_group, status } = filterState
      let obj = {}
      if (id) obj.id = id
      if (name) obj.name = name
      if (status) obj.active = status
      if (property_group) obj.property_group = property_group
      return obj
    },
    updatePropertyPriceGroup: async () => {
      if (!propertyGroupData) {
        notification.warning({
          message: 'Please select a Property Group'
        });
        return;
      }

      let otherResp = events.getParamsForInventoryList()
      let params = { ...otherResp }

      params.property_group = propertyGroupData

        let resp = await dispatch(updatedAllPropertyPriceByGrpFxn({ ...params }))
        if (resp && resp.success) {
          tableRef.current.reload()
        }

    }
  }
  const formItemLayout = {
    labelCol: { xs: { span: 0 }, sm: { span: 0 }, md: { span: 0 } },
    wrapperCol: { xs: { span: 24 }, sm: { span: 24 }, md: { span: 24 } }
  }
  const baseFormFields = [
    {
      key: 'property_group',
      label: 'Select Property Group',

      customField: (
        <InputBox title={'Select Property management group'}>
          <select
            name="smallLogo"
            id="smallLogo"

            value={propertyGroupData}
            className="form-control"
            onChange={(e) => setPropertyGroupData(e.target.value)}
          >
            <option value="">Select Group</option>
            {propertyGrpList.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </InputBox>
      )
    },

  ]
  useEffect(() => {
    events.getDistinctPropertyGrp()
  },[])
  return (
    <Modal
      width={600}
      title={`Update Group Price`}
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <div className='card unizportal'>
        <Row gutter={24}>
          {baseFormFields.map((item, index) => (
            <Col span={24}>
              {item.type === 'file' ? null : item.customField ? (
                <>{item.customField}</>
              ) : (
                <GetEachFormFields
                  item={item}
                  getFieldDecorator={getFieldDecorator}
                  formItemLayout={formItemLayout}
                />
              )}
            </Col>
          ))}


        </Row>
        <Row>
          <Col span={24}>
            <Form.Item>
              <button className='btn' type='submit' onClick={() => {events.updatePropertyPriceGroup()}}>Update Price</button>
            </Form.Item>
          </Col>
        </Row>
      </div>

    </Modal>
  );
};
const UpdateGroupPriceModal = Form.create()(UpdateGroupPrice);

const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateGroupPriceModal);
